import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "suitcaseFilled"
const SuitcaseFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.5 20.25C22.5 21.078 21.828 21.75 21 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V13.307C2.213 13.896 3.128 14.25 4.125 14.25H9.75V14.625C9.75 15.453 10.422 16.125 11.25 16.125H12.75C13.578 16.125 14.25 15.453 14.25 14.625V14.25H19.875C20.872 14.25 21.787 13.896 22.5 13.307z" />
          <path d="M12.75 11.625V14.625H11.25V11.625z" />
          <path
            fillRule="evenodd"
            d="M14.25 3C15.078 3 15.75 3.672 15.75 4.5V6H21.002C21.831 6 22.5 6.672 22.5 7.5V10.125C22.5 11.575 21.325 12.75 19.875 12.75H14.25V11.625C14.25 10.797 13.578 10.125 12.75 10.125H11.25C10.422 10.125 9.75 10.797 9.75 11.625V12.75H4.125C2.675 12.75 1.5 11.575 1.5 10.125V7.5C1.5 6.672 2.17 6 2.998 6H8.25V4.5C8.25 3.672 8.922 3 9.75 3zM9.75 6H14.25V4.5H9.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SuitcaseFilledIcon
